export default "__VITE_ASSET__e09a1996__"